export default __webpack_public_path__ + "static/media/cchat-robot-guide.20c20a9a.png";